// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CookieSidebar__logo{margin-top:3rem;margin-bottom:3rem}.CookieSidebar__title{margin-bottom:1rem}.CookieSidebar__intro{margin-bottom:3rem}.CookieSidebar__checkbox{margin-top:1.5rem;margin-bottom:1.5rem}.CookieSidebar__submit{margin-top:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
